module.exports = __webpack_public_path__ + "static/img/can-bkg.1512cf9a.png";